<template>
  <div class="props-group">
      <div class="private time-design">
        <el-form-item label="计时方式">
          <el-select v-model="component.properties.calTimeType" placeholder="请选择">
            <el-option label="正计时" value="positiveTiming"></el-option>
            <el-option label="倒计时" value="countdown"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检测时间点">
          <el-select v-model="component.properties.checkTime" placeholder="请选择">
            <el-option label="页面初次打开" value="first"></el-option>
            <el-option label="页面近次打开" value="lately"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="定时时长" v-if="component.properties.calTimeType==='countdown'"
            prop="properties.time"
            :rules="{type:'object',validator: this.includeOne, options:[{ hh:component.properties.time.HH,mm:component.properties.time.mm,ss:component.properties.time.ss}], trigger: 'blur'}">
            <el-input type="number" v-model="component.properties.time.HH" min="0" max="24"> <template slot="append">时</template></el-input>
            <el-input type="number" v-model="component.properties.time.mm" min="0" max="60"> <template slot="append">分</template></el-input>
            <el-input type="number" v-model="component.properties.time.ss" min="0" max="60"> <template slot="append">秒</template></el-input>
        </el-form-item>
      </div>
  </div>
</template>

<script>
export default {
  name: 'attr-time',
  props: [ 'component' ],
  methods: {
    includeOne  (rule, value, callback) {
      let array = []
      for (let key in rule.options[0]) {
        if (rule.options[0][key] || rule.options[0][key] === 0) {
          array.push(rule.options[0][key])
        }
      }
      if (array.length !== 3) {
        callback(new Error('请输入倒计时时间'))
      }
      callback()
    }
  }
}
</script>
<style lang="scss">
.private {
  border-top: 1px solid #c2c3c4;
  margin: 0 -20px;
  padding: 0 20px;
}
.time-design {
  .el-input-group__append {
    padding: 0 5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/time.vue